import { render, staticRenderFns } from "./print_receipt.vue?vue&type=template&id=22b8a7a6&scoped=true"
import script from "./print_receipt.vue?vue&type=script&lang=js"
export * from "./print_receipt.vue?vue&type=script&lang=js"
import style0 from "./print_receipt.vue?vue&type=style&index=0&id=22b8a7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8a7a6",
  null
  
)

export default component.exports